import type { CancelTokenSource } from 'axios';

const CANCEL_MESSAGE = 'cancelled';

const queue = new Set<CancelTokenSource>();

function add(source: CancelTokenSource) {
  queue.add(source);
}

function clear(token: CancelTokenSource['token'], cancel = false) {
  queue.forEach((source) => {
    if (source.token === token) {
      if (cancel) {
        source.cancel(CANCEL_MESSAGE);
      }
      queue.delete(source);
    }
  });
}

function clearAll() {
  queue.forEach((source) => {
    source.cancel(CANCEL_MESSAGE);
  });
  queue.clear();
}

export default {
  add,
  clear,
  clearAll,
};
